// /src/components/private/funding/fundingApi.js

import axios from 'axios';
import { fetchDonatePanelPublic } from '../../../pages/private/admin/PrivateDocuments/donatePanel/donatePanelApi';

export async function fetchFundingPanelBundle() {
  const data = await fetchDonatePanelPublic();
  return {
    panel: data?.data || null,
    fundingWsMaxSeq: Number(data?.fundingWsMaxSeq ?? 0),
  };
}

export async function fundingLastSeen(lastSeenWsLogId) {
  const { data } = await axios.post(
    '/api/user/funding-last-seen',
    typeof lastSeenWsLogId === 'undefined' ? {} : { lastSeenWsLogId },
    { withCredentials: true },
  );
  return data;
}

export async function getFundingDiff() {
  const { data } = await axios.post(
    '/api/user/funding-diff',
    {},
    { withCredentials: true },
  );
  return data;
}

export function extractFundingStatsFromWsPayload(payload) {
  const meta = payload?.meta;
  if (!meta || typeof meta !== 'object') return null;

  const currentMonthDonationEur = Number(meta.currentMonthDonationEur);
  const currentYearDonationEur = Number(meta.currentYearDonationEur);
  if (!Number.isFinite(currentMonthDonationEur) || !Number.isFinite(currentYearDonationEur)) {
    return null;
  }

  return {
    currentMonthDonationEur,
    currentYearDonationEur,
    wsLogId: Number(payload?.wsLogId ?? 0),
  };
}
